export class FootnoteRowModel {
    public underLyingGridRowId: number;
    public identifier: string;
    public text: string;
    public isDeleted: boolean;
}
